<template>
    <b-nav tabs fill>
        <b-nav-item link-classes="bg-transparent text-small" :to="{name: 'login'}" exact
                    exact-active-class="active">
            {{t('Login')}}
        </b-nav-item>
        <b-nav-item :to="{name: 'country', query: {to: {name: 'sign-up'}}}"
                    :link-classes="['bg-transparent text-small', {'active router-link-active': $route.name === 'sign-up'}]"
                    exact
                    exact-active-class="active">{{t('Sign up')}}
        </b-nav-item>
    </b-nav>
</template>

<script>
    export default {
        name: "AuthNav",
        computed: {
            active() {
                return this.$route.name === 'sign-up'
            }
        }
    }
</script>

<style scoped>
    .text-small {
        font-size: 15px;
        color: #acacac;
        border-bottom: solid 3px;
    }

    .active {
        border-color: transparent transparent #3266F5 !important;
    }
</style>
